module.exports = __webpack_public_path__ + "img/icon-table-create.d465ded4.svg";